<template>
  <div class="cardTicketList-detail">
    <div class="msg">
      <h1>订单生成</h1>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
        class="form"
      >
        <el-form-item label="小票：">
          <el-image
            style="width: 100px; height: 100px"
            :src="url"
            :preview-src-list="srcList"
          ></el-image>
        </el-form-item>
        <el-form-item label="小票单号：" prop="orderId">
          <el-input v-model="form.orderId" placeholder="请输入小票单号"></el-input>
        </el-form-item>
        <el-form-item label="积分：" prop="ticketIntegral">
          <el-input v-model="form.ticketIntegral" placeholder="请输入积分值"></el-input>
        </el-form-item>
        <el-form-item label="购买时间：" prop="buyTime">
          <el-date-picker
            v-model="form.buyTime"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="record">
      <h1>
        <el-button type="primary" @click="visible = true">添加</el-button>
      </h1>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="购买时间" align="center"></el-table-column>
        <el-table-column prop="productName" label="购买商品" align="center"></el-table-column>
        <el-table-column prop="buyNum" label="购买数量" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="submit">
      <el-button type="primary" :loading="loading" @click="onSubmit('form')">保存</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
    <addDialog :visible="visible" @close="visible = false" @confirm="handleConfirm"/>
  </div>
</template>
<script>
import { getSmallTicket, addBuyRecord } from '@/api/audit';
import { validCurrency } from '@/utils/validate';
import { formatDateTime } from '@/utils/util';
import addDialog from './components/addDialog.vue';

export default {
  data() {
    const validcurrency = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      url: '',
      srcList: [],
      visible: false,
      form: {
        smallTicketId: '',
        userId: '',
        orderId: '',
        shopName: '',
        ticketIntegral: '',
        buyTime: '',
        products: [],
      },
      tableData: [],
      loading: false,
      rules: {
        orderId: [
          { required: true, message: '请输入小票单号', trigger: 'blur' },
        ],
        ticketIntegral: [
          { required: true, message: '积分不能为空', trigger: 'blur' },
          { validator: validcurrency, trigger: 'blur' },
        ],
        buyTime: [
          { required: true, message: '请选择购买时间', trigger: 'blur' },
        ],
      },
    };
  },
  components: {
    addDialog,
  },
  mounted() {
    this.getSmallTicket();
  },
  methods: {
    // 获取小票信息
    getSmallTicket() {
      const { id } = this.$route.query;
      getSmallTicket(id).then((res) => {
        if (res.success) {
          const {
            ticketUrl, shopName, userId,
          } = res.data;
          this.url = ticketUrl;
          this.srcList = [ticketUrl];
          this.form.shopName = shopName;
          this.form.userId = userId;
          this.form.smallTicketId = id;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addBuyRecord() {
      this.loading = true;
      addBuyRecord(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('添加成功');
          this.$router.push({ name: 'BuyrecordList' });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 添加
    handleConfirm(data) {
      if (!this.form.buyTime) {
        this.$message.warning('请选择购买时间后添加商品');
      } else {
        const newData = {
          ...data,
          id: this.tableData.length + 1,
          createTime: formatDateTime(this.form.buyTime),
        };
        this.tableData.push(newData);
        this.visible = false;
      }
    },
    // 删除
    handleDel(id) {
      this.tableData = this.tableData.filter((item) => item.id !== id);
    },
    // 订单生成
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tableData.length !== 0) {
            this.form.products = this.tableData;
            this.addBuyRecord();
            return true;
          }
          this.$message.warning('请添加购买商品后生成订单');
        }
        return false;
      });
    },
    // 取消
    handleCancel() {
      this.$router.push({
        name: 'AuditList',
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.cardTicketList-detail
  .form
    width 500px
    // margin 0 auto
  .msg
    border-bottom 1px solid #e8e8e8
    padding-bottom 24px
    h1
      margin-bottom 20px
      color rgba(0, 0, 0, 0.85)
      font-weight 700
      font-size 16px
      line-height 1.5
  .record
    margin-top 30px
    h1
      margin-bottom 16px
      color rgba(0, 0, 0, 0.85)
      font-weight 500
      font-size 16px
      flex-row()
      justify-content flex-end
  .submit
    margin-top 50px
    text-align center
</style>
